import deprecated from '@wordpress/deprecated';
import { forwardRef } from '@wordpress/element';
import Button from '.';
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedIconButton({
  label,
  labelPosition,
  size,
  tooltip,
  ...props
}, ref) {
  deprecated('wp.components.IconButton', {
    since: '5.4',
    alternative: 'wp.components.Button',
    version: '6.2'
  });
  return (
    /*#__PURE__*/
    // Disable reason: the parent component is taking care of the __next40pxDefaultSize prop.
    // eslint-disable-next-line @wordpress/components-no-missing-40px-size-prop
    _jsx(Button, {
      ...props,
      ref: ref,
      tooltipPosition: labelPosition,
      iconSize: size,
      showTooltip: tooltip !== undefined ? !!tooltip : undefined,
      label: tooltip || label
    })
  );
}
export default forwardRef(UnforwardedIconButton);